import styles from './Form.module.scss.js';
import messages from './intl/index.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useMessageFormatter } from '../i18n/format.js';
import { Text } from '../text/Text.js';
import { StandaloneIcon } from '../icon/Icon.js';
import { MdError, MdInfo, MdWarning, MdCheckCircle } from '../node_modules/react-icons/md/index.js';

function FieldMessages(props) {
  const {
    kind,
    value
  } = props;
  // TODO what do with rest

  const {
    formatMessage
  } = useMessageFormatter(messages);
  let els = [];
  let iconEl = /*#__PURE__*/jsx(Fragment, {});
  const callerEls = toArr(value);
  if (callerEls.length === 0) {
    return /*#__PURE__*/jsx(Fragment, {});
  }
  if (kind === 'error') {
    els = callerEls.map((x, i) => /*#__PURE__*/jsx(Text, {
      variant: "helper",
      color: "color-danger",
      children: x
    }, i));
  } else if (kind === 'success') {
    els = callerEls.map((x, i) => /*#__PURE__*/jsx(Text, {
      variant: "helper",
      color: "color-success",
      children: x
    }, i));
  } else {
    els = callerEls.map((x, i) => /*#__PURE__*/jsx(Text, {
      variant: "helper",
      children: x
    }, i));
  }
  if (kind === 'error') {
    iconEl = /*#__PURE__*/jsx(StandaloneIcon, {
      className: styles['message-icon'],
      icon: MdError,
      color: "color-danger",
      title: formatMessage('Error')
    });
  } else if (kind === 'prominent-help') {
    iconEl = /*#__PURE__*/jsx(StandaloneIcon, {
      className: styles['message-icon'],
      icon: MdInfo,
      color: "color-primary",
      title: formatMessage('Help')
    });
  } else if (kind === 'warning') {
    iconEl = /*#__PURE__*/jsx(StandaloneIcon, {
      className: styles['message-icon'],
      icon: MdWarning,
      color: "color-warn",
      title: formatMessage('Warning')
    });
  } else if (kind === 'success') {
    iconEl = /*#__PURE__*/jsx(StandaloneIcon, {
      className: styles['message-icon'],
      icon: MdCheckCircle,
      color: "color-success",
      title: formatMessage('Success')
    });
  }
  return /*#__PURE__*/jsxs("div", {
    style: {
      display: 'flex',
      gap: 'var(--size-100)'
    },
    children: [iconEl, /*#__PURE__*/jsx("div", {
      className: styles['field-container'],
      children: els
    })]
  });
}
function toArr(value) {
  if (typeof value === 'undefined') {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  return [value];
}

export { FieldMessages };
